import { render } from "./LendRecord.vue?vue&type=template&id=4e4c6e88"
import script from "./LendRecord.vue?vue&type=script&lang=js"
export * from "./LendRecord.vue?vue&type=script&lang=js"

import exportComponent from "D:\\图书管理系统VUE\\Vue-Springboot-Library\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__